export default __webpack_public_path__ + "static/media/undereyeDarkness.1fc3f7b2.svg";